document.addEventListener('DOMContentLoaded', () => {
  console.log('LGO infinite scroll active');

  const gridSelector = 'ul#product-grid';
  const paginationSelector = '.pagination-wrapper';

  let loading = false;
  let loader;

  // Unique key per collection + filter state
  const STORAGE_KEY =
    'lgoInfiniteState:' + window.location.pathname + window.location.search;

  /* --------------------------
     STATE SAVE / RESTORE
  --------------------------- */

  function saveState() {
    try {
      const grid = document.querySelector(gridSelector);
      const pagination = document.querySelector(paginationSelector);
      if (!grid) return;

      const state = {
        scrollY: window.scrollY || window.pageYOffset,
        gridHTML: grid.innerHTML,
        paginationHTML: pagination ? pagination.innerHTML : null,
      };

      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      // console.log('LGO infinite scroll: state saved');
    } catch (e) {
      console.warn('LGO infinite scroll: save failed', e);
    }
  }

  function restoreStateIfBackNavigation() {
    try {
      const navEntries = performance.getEntriesByType('navigation');
      const isBackForward =
        navEntries && navEntries[0] && navEntries[0].type === 'back_forward';

      const saved = sessionStorage.getItem(STORAGE_KEY);
      if (!saved) return;

      const state = JSON.parse(saved);

      // Only restore on real back/forward navigation
      if (!isBackForward) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      const grid = document.querySelector(gridSelector);
      const pagination = document.querySelector(paginationSelector);
      if (!grid) return;

      if (state.gridHTML) {
        grid.innerHTML = state.gridHTML;
      }
      if (pagination && state.paginationHTML !== null) {
        pagination.innerHTML = state.paginationHTML;
      }

      // Scroll after layout
      requestAnimationFrame(() => {
        window.scrollTo(0, state.scrollY || 0);
      });

      console.log('LGO infinite scroll: state restored');
    } catch (e) {
      console.warn('LGO infinite scroll: restore failed', e);
    }
  }

  restoreStateIfBackNavigation();

  /* Save when user clicks a product card link inside the grid */
  const gridForClicks = document.querySelector(gridSelector);
  if (gridForClicks) {
    gridForClicks.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      // Only bother for same-origin navigation
      if (link.origin === window.location.origin) {
        saveState();
      }
    });
  }

  // Fallback: save on page unload as well
  window.addEventListener('beforeunload', saveState);

  /* --------------------------
     LOADER
  --------------------------- */

  function setupLoader() {
    const pagination = document.querySelector(paginationSelector);
    if (!pagination || loader) return;

    loader = document.createElement('div');
    loader.id = 'lgo-infinite-loader';
    loader.textContent = 'Loading more items…';
    loader.style.display = 'none';

    // Insert loader BEFORE the pagination
    pagination.parentElement.insertBefore(loader, pagination);
  }

  function showLoader() {
    if (!loader) setupLoader();
    if (loader) loader.style.display = 'block';
  }

  function hideLoader() {
    if (loader) loader.style.display = 'none';
  }

  /* --------------------------
     EXISTING INFINITE SCROLL
  --------------------------- */

  function getNextLink(doc = document) {
    // Dawn uses "pagination__item--prev" for NEXT page arrow
    return doc.querySelector('.pagination a.pagination__item--prev');
  }

  async function loadNextPage() {
    if (loading) return;

    const nextLink = getNextLink();
    if (!nextLink) {
      console.log('LGO infinite scroll: no next page link found');
      hideLoader();
      return;
    }

    loading = true;
    showLoader();
    console.log('LGO infinite scroll: loading', nextLink.href);

    try {
      const res = await fetch(nextLink.href);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector(gridSelector);
      const currentGrid = document.querySelector(gridSelector);

      if (newGrid && currentGrid) {
        while (newGrid.firstElementChild) {
          const item = newGrid.firstElementChild;
          item.classList.add('lgo-fade-in');
          currentGrid.appendChild(item);
        }
      }

      // Update pagination wrapper for the next page
      const newPagination = doc.querySelector(paginationSelector);
      const currentPagination = document.querySelector(paginationSelector);
      if (currentPagination) {
        if (newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        } else {
          currentPagination.remove();
        }
      }

      // After adding new items, update saved state
      saveState();
    } catch (err) {
      console.error('LGO infinite scroll error:', err);
    } finally {
      loading = false;
      hideLoader();
    }
  }

  setupLoader();

  window.addEventListener('scroll', () => {
    const scrollPos = window.innerHeight + window.pageYOffset;
    const trigger = document.body.offsetHeight - 800;
    if (scrollPos > trigger) loadNextPage();
  });
});